import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from "rxjs";
import { CartService } from "../../shared/services/cart.service";
import { ProductService } from "../../shared/services/product.service";
import { EnumService } from "../../shared/services/enum.service";

@Component({
  selector: "app-cart-dialog",
  templateUrl: "./cart-dialog.component.html",
  styleUrls: ["./cart-dialog.component.sass"],
})
export class CartDialogComponent implements OnInit {
  cartItems: any[] = [];
  esMovil: boolean = false;
  constructor(
    public productsService: ProductService,
    private cartService: CartService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private enumService: EnumService,
    public dialogRef: MatDialogRef<CartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public product: any
  ) {}

  ngOnInit(): void {
    this.cartService.getItems().subscribe((res: any) => {
      this.cartItems = res;
      this.cartItems.forEach((x, i) => {
        x.idTable = i + 1;
      });
      setTimeout(() => {
        document
          .getElementById(String(this.cartItems.length))
          .scrollIntoView(true);
      }, 100);
      setTimeout(() => {
        this.cartItems.forEach((x, i) => {
          x.fondoColor = "";
        });
      }, 3000);
    });
  }
  public close(): void {
    this.dialogRef.close();
  }
  public removeItem(item: any) {
    this.cartService.removeFromCart(item);
  }
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }
  ngDoCheck() {
    this.cambiarBanner();
  }
  irApagar() {
    this.spinner.show();
    this.router.navigate(["/pages/cart"]);
    this.enumService.setTitleMeta("Novaplaza | Tecnología de nivel", {
      name: "description",
      content:
        "Ofrecemos la más grande variedad de Laptops, Computadoras, Impresoras,Tablets, Accesorios, Zona Gamer, Software, Equipos de Bioseguridad,Herramientas para trabajar y estudiar en casa.",
    });
    this.close();
  }
  cambiarBanner() {
    let tamaño = window.innerWidth;
    if (tamaño <= 600) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }
}
